import React, { FunctionComponent } from "react"
import Loader from "src/components/common/Loader"
import "./LoginLoader.css"
 
const LoginLoader: FunctionComponent<{}> = () => {
    return ( 
        <div className="LoginLoader">
            <Loader title="Logging you in..." />
        </div>
     )
}
 
export default LoginLoader